import React, { useState } from 'react'
import { Accordion, Collapse } from 'react-bootstrap'
import {BiDownArrow, BiUpArrow} from 'react-icons/bi'
export default function Toxicos({ item, index }) {
  const [open, setOpen] = useState(false);

  //CNS
  const isPhase = item.phase || item.phase1;
  //

  return (
    <div>
      <Accordion.Item eventKey={index} index={index}>
        <Accordion.Header>{item.name}</Accordion.Header>
        <Accordion.Body className='accordionBody'>
          {
            item.description &&
            <div>
              {item.description}
            </div>
          }
          <div className='text-end'>
           { open && <BiUpArrow onClick={() => setOpen(false)} />}
           {
            !open &&
            <div><BiDownArrow onClick={() => setOpen(true)} /> Leer más</div>
          }
          </div>
          <Collapse in={open}>
            <div id="example-collapse-text">
              {
                item.posology &&
                <div>
                  <b>Posología: </b>
                  {item.posology}
                </div>
              }
              {
                item.poskids &&
                <div>
                  <b>Posología Niños: </b>
                  {item.poskids}
                </div>
              }
              {
                item.posadults &&
                <div>
                  <b>Posología Adultos: </b>
                  {item.posadults}
                </div>
              }
              {
                item.toxicocinetic &&
                <div>
                  <b>Toxicocinética: </b>
                  {item.toxicocinetic}
                </div>
              }
              {
                item.actionmec &&
                <div>
                  <b>Mecanismo de Acción: </b>
                  {item.actionmec}
                </div>
              }
              {
                item.toxicmec &&
                <div>
                  <b>Mecanismo de Toxicidad: </b>
                  {item.toxicmec}
                </div>
              }
              {
                item.toxicdose &&
                <div>
                  <b>Dosis Tóxica: </b>
                  {item.toxicdose}
                </div>
              }
              {
                item.toxicdosekids &&
                <div>
                  <b>Dosis Tóxica Niños: </b>
                  {item.toxicdosekids}
                </div>
              }
              {
                item.toxicdoseadults &&
                <div>
                  <b>Dosis Tóxica Adultos: </b>
                  {item.toxicdoseadults}
                </div>
              }
              {
                isPhase  &&
                <div style={{background: "white", color: "black", padding: "0px", marginLeft:"0px" }}>
                  <b>Signos y Síntomas</b>
                </div>
              }
              {
                item.phase &&
                <div>
                  {/*<b>Fase (síntomas): </b>*/}
                  {item.phase}
                </div>
              }
              {
                item.phase1 &&
                <div style={{padding: "5px", marginLeft:"15px" }}>
                  <b>Fase 1: </b>
                  {item.phase1}
                </div>
              }
              {
                item.phase2 &&
                <div style={{padding: "5px", marginLeft:"15px" }}>
                  <b>Fase 2: </b>
                  {item.phase2}
                </div>
              }
              {
                item.phase3 &&
                <div style={{padding: "5px", marginLeft:"15px" }}>
                  <b>Fase 3: </b>
                  {item.phase3}
                </div>
              }
              {
                item.phase4 &&
                <div style={{padding: "5px", marginLeft:"15px" }}>
                  <b>Fase 4: </b>
                  {item.phase4}
                </div>
              }
              {
                item.general &&
                <div>
                  <b>Manejo Clínico: </b>
                  {item.general}
                </div>
              }
              {
                item.descontamination &&
                <div>
                  <b>Descontaminación: </b>
                  {item.descontamination}
                </div>
              }
              {
                item.antidoteuse &&
                <div>
                  <b>Uso de antídoto: </b>
                  {item.antidoteuse}
                </div>
              }
            </div>
          </Collapse>


        </Accordion.Body>
      </Accordion.Item>
    </div>
  )
}
